<template>
  <v-container>
    <page-header v-if="genre" :title="genre.label" :info="lang.genreInfo(genre.label.toLowerCase())" />
    <grid :items="items" :headers="headers" />
    <div v-if="genre" hidden v-html="`${genre.label} - ${lang.genreInfo(genre.label.toLowerCase())}`" :class="['meta-description']" />
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'
import data from '../helpers/data'

export default {
  name: 'genres-genre',
  mixins: [
    data,
    methods
  ],
  data () {
    return {
      lang,
      id: null,
      genre: null
    }
  },
  watch: {
    /**
     * route.params.genre watcher
     */
    '$route.params.genre' () {
      this.getGenreConfig()
    }
  },
  mounted () {
    this.getGenreConfig()
  },
  methods: {
    /**
     * Get the page data from the API
     * @method getGenreConfig
     * @return {void}
     */
    getGenreConfig () {
      this.id = this.$route.params.genre
      this.genre = this.$root.genres.find(genre => genre.id === this.id)
      this.getTabularData('genres', this.id, 'genre', () => {
        this.$nextTick(() => {
          this.setLastBreadcrumbsItemText(this.genre.label)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/genres-genre.vue